import React, { useState, useEffect } from "react";
import "./Header.css";

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNavbar = () => {
    setIsNavOpen(!isNavOpen);
  };

  const closeNavbar = () => {
    setIsNavOpen(false);
  };

  const [isHeaderActive, setIsHeaderActive] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsHeaderActive(window.scrollY >= 10);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className={`header ${isHeaderActive ? "active" : ""}`} data-header>
      <div className="container">
        <h1 className="h1 logo">
          <a href="#home">
            Bhaskar<span>.</span>
          </a>
        </h1>

        <div className="navbar-actions">{/* Removed the theme button */}</div>

        <button
          className={`nav-toggle-btn ${isNavOpen ? "active" : ""}`}
          aria-label="Toggle Menu"
          title="Toggle Menu"
          onClick={toggleNavbar}
        >
          <span className="one"></span>
          <span className="two"></span>
          <span className="three"></span>
        </button>

        <nav className={`navbar ${isNavOpen ? "active" : ""}`} data-navbar>
          <ul className="navbar-list">
            <li>
              <a href="#home" className="navbar-link" onClick={closeNavbar}>
                Home.
              </a>
            </li>
            <li>
              <a href="#about" className="navbar-link" onClick={closeNavbar}>
                About.
              </a>
            </li>
            <li>
              <a href="#skills" className="navbar-link" onClick={closeNavbar}>
                Skills.
              </a>
            </li>
            <li>
              <a
                href="#portfolio"
                className="navbar-link"
                onClick={closeNavbar}
              >
                Portfolio.
              </a>
            </li>
            <li>
              <a href="#contact" className="navbar-link" onClick={closeNavbar}>
                Contact.
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
